import {post, get, patch} from "./axios";

export function notBlank(str) {
  return str !== null && str !== undefined && str !== ''
}

//按 id 查询空防客舱扰乱事件
export function detailById(id) {
  return get(`/plane-cabin-event/${id}`)
}

//分页查询空防客舱扰乱纵火事件
export function pageKeCang(pager, data) {
  return get(`/plane-cabin-event/page-user/${pager.number}/${pager.limit}`, data)
}

//答题
export function answer(data) {
  return post('/plane-cabin-event/choose-answer', data)
}

//同意决策
export function agreeSystem(data) {
  return post('/plane-cabin-event/soc-confirm', data)
}

//add task
export function addTask(data) {
  return post('/plane-cabin-event/add-task', data)
}

//handle task
export function handleTask(data) {
  return post('/plane-cabin-event/choose-task-answer', data)
}

//handle task
export function chooseTaskAnswerProxy(tokenClient, data) {
  return post(`/plane-cabin-event/choose-task-answer/${tokenClient}`, data)
}

//fidn fire
export function findFire(id) {
  return post(`/plane-cabin-event/discover-fire/${id}`)
}

//发现火情
export function discoverFire(type,id) {
  return post(`/plane-cabin-event/discover-fire/${type}/${id}`)
}

//发现秩序失控
export function discoverOutControl(type,id) {
  return post(`/plane-cabin-event/discover-out-control/${type}/${id}`)
}

//发现爆炸风险
export function discoverExplosive(type,id) {
  return post(`/plane-cabin-event/discover-explosive/${type}/${id}`)
}

//finish all task
export function finishTask(id, type) {
  return patch(`/plane-cabin-event/done/${type}/${id}`)
}

//
export async function findFight(id) {
  return post(`/plane-cabin-event/discover-fight/${id}`)
}

export async function taskDone(type,id) {
  return patch(`/plane-cabin-event/task-done/${type}/${id}`)
}

export async function taskDoneProxy(tokenClient, type,id) {
  return patch(`/plane-cabin-event/task-done-proxy/${tokenClient}/${type}/${id}`)
}

/**
 * 选择事件类型
 * @param dv {string} 数据版本号
 * @param type {string} 事件类型：CET0:纵火 , CET1:斗殴
 * @returns {Promise<object>}
 */
export async function chooseType(dv, type) {
  return patch(`/plane-cabin-event/choose/${dv}/${type}`, {})
}

/**
 * 获取拉流地址
 * @param id {string} 事件id
 * @param protocol {string} 拉流协议： wss
 * @returns {Promise<object>}
 */
export async function getHikStreamVO(id, protocol) {
  return get(`/plane-cabin-event/hik-stream/${id}/${protocol}`)
}

/**
 * 获取拉流地址
 * @param id {string} 事件id
 * @param protocol {string} 拉流协议： wss
 * @param yyyyMMddHHmmssBegin {string} 开始时间，指定开始时间和结束时间表示看回放记录
 * @param yyyyMMddHHmmssEnd {string} 结束时间，指定开始时间和结束时间表示看回放记录
 * @returns {Promise<object>}
 */
export async function getDeviceHikStreamVO(id, protocol, yyyyMMddHHmmssBegin, yyyyMMddHHmmssEnd) {
  if (yyyyMMddHHmmssBegin && yyyyMMddHHmmssEnd){
    return get(`/hik-device/hik-stream/${id}/${protocol}/${yyyyMMddHHmmssBegin}/${yyyyMMddHHmmssEnd}`)
  }
  return get(`/hik-device/hik-stream/${id}/${protocol}`)
}

/**
 * 人脸搜索
 * @param base64 {string} base64图片
 * @returns {Promise<object>}
 */
export async function searchFaceByBase64(base64) {
  return post(`/person/search-face-base64`, base64)
}




// WEBPACK FOOTER //
// ./src/api/kecang.js